import React from 'react';
import PropTypes from 'prop-types';
import { db, firebase } from '../firebase';


const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
        userName: "",
        inGameName: "",
        authUserId: "",
        authEmail: "",
        favorites: [],
        tournaments: [],
        upcomingTournaments: [],
        ethWallet: ""
      };
    }

    getChildContext() {
      return {
        authUser: this.state.authUser,
        userName: this.state.userName,
        inGameName: this.state.inGameName,
        authUserId: this.state.authUserId,
        authEmail: this.state.authEmail,
        favorites: this.state.favorites,
        tournaments: this.state.tournaments,
        upcomingTournaments: this.state.upcomingTournaments,
        ethWallet: this.state.ethWallet
      };
    }

    componentDidMount() {
      var thethis = this;
      var upT = [];
      firebase.auth.onAuthStateChanged(function(authUser) {
        if (authUser) {
          thethis.setState({authUser: authUser, authUserId: authUser.uid, authEmail: authUser.email});
          db.getUser(authUser.uid).then(snapshot =>
            thethis.setState(() =>
            (
              { userName: snapshot.username,
                inGameName: snapshot.inGameName,
                favorites: ("favorites" in snapshot ? snapshot.favorites : []),
                tournaments: ("tournaments" in snapshot ? snapshot.tournaments : []),
                ethWallet: ("ethWallet" in snapshot ? snapshot.ethWallet : "")
              })),

              db.getTournaments().then(querySnapshot =>

                querySnapshot.forEach(function(doc) {
                    upT.push(
                      {"Name": doc.data().Name,
                      "url": doc.data().deckName,
                      "date": doc.data().date,
                    });
                  },

                    thethis.setState(() =>
                      (
                        {
                          upcomingTournaments: upT
                        }
                      )
                    )
                  )
                )
              )
        }
        else{
          thethis.setState(() => ({ authUser: null, userName: "", authUserId: "", inGameName: "", authEmail: "", favorites: [], tournaments: [], ethWallet: "" }));
        }

      });
    }

    render() {
      return (
        <Component />
      );
    }
  }

  WithAuthentication.childContextTypes = {
    authUser: PropTypes.object,
    userName: PropTypes.string,
    inGameName: PropTypes.string,
    authUserId: PropTypes.string,
    authEmail: PropTypes.string,
    favorites: PropTypes.array,
    tournaments: PropTypes.array,
    upcomingTournaments: PropTypes.array,
    ethWallet: PropTypes.string
  };

  return WithAuthentication;
}

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/Authentication/withAuthentication.js